import React from 'react';
import { Select, Option } from 'informed';

import ClassName from 'classnames';

import './ContactFormItem.css';

const ContactFormItem = ({ label, Type, name, placeholder, cols }) => {
  const htmlFor = `${name}-field`;
  const classNames = ClassName('contact-form-item', { 'two-cols': !!cols });
  if (Type === Select) {
    return (
      <div className={classNames}>
        <label htmlFor={htmlFor}>{label}</label>
        <br />
        <Select field="objet" id="select-status">
          <Option value="" disabled>
            {placeholder}
          </Option>
          <Option value="Prise de rendez-vous">Prise de rendez-vous</Option>
          <Option value="Commande">Commande</Option>
          <Option value="Demande de renseignements">
            Demande de renseignements
          </Option>
          <Option value="Partenariat">Partenariat</Option>
          <Option value="Presse">Presse</Option>
          <Option value="Autre">Autre</Option>
        </Select>
      </div>
    );
  }
  return (
    <div className={classNames}>
      <label htmlFor={htmlFor}>{label}</label>
      <br />
      <Type field={name} id={htmlFor} placeholder={placeholder} />
    </div>
  );
};

export default ContactFormItem;



// WEBPACK FOOTER //
// ./src/Components/Contact/ContactFormItem/ContactFormItem.js